import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chart-card',
  standalone: true,
  imports: [CommonModule],
  host: {
    class: 'flex flex-col min-w-0 w-full h-full',
    '[attr.title]': 'null',
  },
  templateUrl: './chart-card.component.html',
})
export class ChartCardComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() breadcrumb: string[] = [];
  @Input() filtered = false;
  @Input() hideHeader = false;

  // Toolbar Drill controls
  @Input() activeControl: 'drillUp' | 'drillDown' | 'nextLevel' | 'expandAll' | 'openDetails' | null = null;
  @Input() disableDrillUp = false;
  @Input() disableDrillDown = false;
  @Input() disableNextLevel = false;
  @Input() disableExpandAll = false;
  @Input() disableOpenDetails = false;
  @Input() openDetailsLabel = '';

  // Hide buttons entirely (removes from DOM, not just disabled)
  @Input() hideDrillUp = false;
  @Input() hideDrillDown = false;
  @Input() hideNextLevel = false;
  @Input() hideExpandAll = false;
  @Input() hideOpenDetails = false;

  @Output() breadcrumbClick = new EventEmitter<number>();
  @Output() drillUp = new EventEmitter<void>();
  @Output() drillDown = new EventEmitter<void>();
  @Output() nextLevel = new EventEmitter<void>();
  @Output() expandAll = new EventEmitter<void>();
  @Output() openDetails = new EventEmitter<void>();
}
